define('MM/Models/ContentSearch/FacetDropdownViewModel',["knockout"], function (ko) {
    "use strict";

    function FacetDropdownViewModel(selectedOptionText, isDisabledDropdownButton) {
        isDisabledDropdownButton = isDisabledDropdownButton || false;
        this.selectedOptionText = ko.observable(selectedOptionText);
        this.isDisabledDropdownButton = ko.observable(isDisabledDropdownButton);
        this.isAnySelected = ko.observable(false);
    }

    return FacetDropdownViewModel;
});
